// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"37":"36a7c823","46":"36a7c823","76":"ac1cf563","639":"6de18c9b"}[chunkId] + ".chunk.css");